export default (theme: Object) => ({
  button: {
    fontSize: theme.typography.tableFontSize,
  },
  primary: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  secondary: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});
